import { render } from "./MessagesGroup.vue?vue&type=template&id=26b88c88&scoped=true"
import script from "./MessagesGroup.vue?vue&type=script&lang=js"
export * from "./MessagesGroup.vue?vue&type=script&lang=js"

import "./MessagesGroup.vue?vue&type=style&index=0&id=26b88c88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b88c88"]])

export default __exports__